var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0C37.7548 0 48.5 10.7452 48.5 24C48.5 37.2548 37.7548 48 24.5 48C11.2452 48 0.5 37.2548 0.5 24C0.5 10.7452 11.2452 0 24.5 0ZM23.5 21C22.3954 21 21.5 21.8954 21.5 23V37C21.5 38.1046 22.3954 39 23.5 39H25.5C26.6046 39 27.5 38.1046 27.5 37V23C27.5 21.8954 26.6046 21 25.5 21H23.5ZM24.5 9C22.8431 9 21.5 10.3431 21.5 12C21.5 13.6569 22.8431 15 24.5 15C26.1569 15 27.5 13.6569 27.5 12C27.5 10.3431 26.1569 9 24.5 9Z",
    fill: "#7951EB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a52a3d2c772f417b663ad941f322c94f.svg";
export { ForwardRef as ReactComponent };